import React, { FC } from "react";
import { ConnectedProps, connect } from "react-redux";
import { RadioGroup, Radio, Label } from "@fluentui/react-components";

import { IUhfViewState } from "../../../../pages/Contracts";
import { IRapComponentProperties } from "../../../../platform/Layout";
import { ITestConfiguration } from "../../Contracts";
import { TestActions } from "../../redux/TestActions";
import { UHFEnvironments } from "../../../../common/Constants";
import { FlexContainer } from "../../../../common/components/FlexContainer/FlexContainer";
import { localizedStrings } from "../../../../common/localization/LocalizedStrings";
import { useSearchParams } from "react-router-dom";

import * as TestSelectors from "../../redux/TestSelectors";

interface IEnvironmentSelectorProvidedProps extends IRapComponentProperties {
    className?: string;
}

interface IEnvironmentSelectorOwnProps {
    testConfig: ITestConfiguration;
}

export type IEnvironmentSelectorProps = ConnectedProps<typeof connector> & IEnvironmentSelectorProvidedProps;

const EnvironmentSelectorInitializer: FC<IEnvironmentSelectorProps> = (props) => {
    const [params, SetParams] = useSearchParams();
    let vNext = params.get("vNext") != null && (params.get("vNext") === "true" || params.get("vNext") === "1");

    return (
        <FlexContainer className={`${props.className ? props.className : ""}`}>
            <Label className="c-field-label">{localizedStrings.TestView?.TestConfigurator?.environment}</Label>
            <RadioGroup aria-label="Environment" layout="horizontal" value={props.testConfig?.environment} onChange={(_, data) => props.setTestConfig({ environment: data.value as UHFEnvironments })}>
                <Radio value={UHFEnvironments.PROD} label="Prod" aria-label="Production"/>
                <Radio value={UHFEnvironments.PPE} label="PPE"  aria-label="Pre-production"/>
                {vNext && (
                    <Radio value={UHFEnvironments.NEXT} label={"UHF 2.0"} aria-label="Next"/>
                )}
            </RadioGroup>
        </FlexContainer>
    );
}

function mapStateToProps(state: IUhfViewState, providedProps: IEnvironmentSelectorProvidedProps): Partial<IEnvironmentSelectorOwnProps> {
    return {
        ...providedProps,
        testConfig: TestSelectors.getTestConfig(state)
    };
}

const ActionsToDispatch = {
    setTestConfig: TestActions.setTestConfig
};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const EnvironmentSelector = connector(EnvironmentSelectorInitializer);